var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWashtaIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: rgba(116, 126, 239, .1);\n        stroke: #747eef;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #747eef;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6,36c0-14.14,0-21.21,4.39-25.61s11.46-4.39,25.61-4.39,21.21,0,25.61,4.39c4.39,4.39,4.39,11.46,4.39,25.61s0,21.21-4.39,25.61c-4.39,4.39-11.46,4.39-25.61,4.39s-21.21,0-25.61-4.39c-4.39-4.39-4.39-11.46-4.39-25.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.83,44.99c.57-1.88.12-3.5-1.26-4.6-1.26-1.01-3.31-1.12-4.75-.27-1.58.94-2.26,2.81-1.85,5.17h-20.72c-.05-.81-.04-1.6-.17-2.36-.37-2.09-2.2-3.54-4.24-3.44-2.07.1-3.76,1.83-3.92,4.04-.04.53,0,1.07,0,1.76-1.11-.13-2.24-.23-3.35-.42-.23-.04-.5-.39-.59-.65-.45-1.21-.49-2.48.13-3.61.31-.57.94-1.1,1.55-1.33,1.56-.6,3.15-1.21,4.79-1.47,3.43-.55,6.69-1.5,9.78-3.1,4.41-2.28,9.15-2.53,13.99-2.26,4.44.25,8.51,1.86,12.66,3.22.77.25,1.51.56,2.28.82.54.18.77.54.67,1.09-.24,1.33-.18,2.64.1,3.95.05.26.04.54.02.81-.1,1.47-.34,1.75-1.77,2.05-1.07.23-2.15.42-3.23.63-.04,0-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.08,47.46c-2.05.04-3.73-1.59-3.76-3.66-.03-1.98,1.6-3.67,3.59-3.72,2.07-.05,3.77,1.55,3.82,3.6.05,2.05-1.57,3.73-3.65,3.77Zm2.44-3.71c0-1.38-1.11-2.48-2.49-2.49-1.39-.01-2.53,1.14-2.52,2.53.01,1.37,1.13,2.49,2.5,2.5,1.39.01,2.52-1.13,2.51-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.26,43.77c0-2.05,1.61-3.68,3.65-3.69,2.08-.01,3.72,1.61,3.73,3.68,0,2.06-1.64,3.7-3.72,3.69-2.03,0-3.66-1.64-3.66-3.69Zm3.69-2.52c-1.38,0-2.53,1.16-2.52,2.55.01,1.35,1.16,2.49,2.51,2.49,1.38,0,2.54-1.17,2.53-2.55-.01-1.35-1.17-2.49-2.52-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.37,22.02c-1.44.33-2.49.95-2.49,2.68-.06-.03-.13-.06-.19-.09-.14-.45-.32-.9-.42-1.36-.09-.41-.29-.64-.71-.74-.47-.12-.92-.32-1.49-.52.33-.11.53-.23.75-.25,1.06-.1,1.6-.7,1.76-1.72.03-.2.13-.39.25-.73.19.61.37,1.08.48,1.56.09.39.29.6.67.7.47.12.93.31,1.39.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.26,22.02c.1-.08.13-.12.17-.12,1.41-.25,2.32-.98,2.28-2.6.06.02.13.04.19.05.17.46.36.92.49,1.4.11.38.31.59.7.68.48.11.95.28,1.58.46-.61.21-1.08.4-1.56.54-.39.1-.58.31-.67.7-.11.48-.28.94-.47,1.56-.2-.58-.37-.99-.48-1.42-.12-.5-.4-.76-.91-.86-.42-.08-.83-.24-1.3-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.01,28.97c0,.66-.62,1.28-1.28,1.28-.7,0-1.31-.63-1.29-1.32.02-.67.63-1.26,1.3-1.24.67.01,1.27.62,1.26,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.45,25.44c.17.89.64,1.37,1.53,1.48-.87.19-1.36.64-1.45,1.54-.19-.87-.68-1.36-1.57-1.48.85-.17,1.4-.58,1.48-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.71,27.05q.94-.4,1.56-1.55c.09.9.51,1.44,1.43,1.56-.88.13-1.38.6-1.54,1.49-.14-.87-.56-1.4-1.45-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.07,21.17c0,.49-.44.9-.94.88-.47-.02-.85-.42-.84-.9,0-.5.41-.88.92-.86.48.02.86.41.85.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.74,34.73c0,.5-.42.9-.92.89-.47-.01-.85-.4-.85-.88,0-.51.4-.89.91-.88.48.01.86.4.86.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.35,31.74c-.24-.24-.54-.56-.8-.83.23-.21.57-.52.86-.78.22.23.52.56.78.84-.22.2-.55.5-.84.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m26.1,30.84c-.23.24-.54.56-.8.83-.22-.23-.53-.55-.8-.82.23-.24.55-.55.81-.82.22.23.54.55.79.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashtaIcons);
export default __webpack_public_path__ + "static/media/Washta-Icons.266226d8bca4b921a367a1d5c7ca0ef9.svg";
export { ForwardRef as ReactComponent };